function d() {
  let r;
  return {
    before(_ref) {
      let {
        doc: e
      } = _ref;
      var l;
      let o = e.documentElement,
        t = (l = e.defaultView) != null ? l : window;
      r = Math.max(0, t.innerWidth - o.clientWidth);
    },
    after(_ref2) {
      let {
        doc: e,
        d: o
      } = _ref2;
      let t = e.documentElement,
        l = Math.max(0, t.clientWidth - t.offsetWidth),
        n = Math.max(0, r - l);
      o.style(t, "paddingRight", "".concat(n, "px"));
    }
  };
}
export { d as adjustScrollbarPadding };